import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  ScrollView,
  Platform,
  TouchableHighlight,
} from "react-native";
// import Switch from "../components/ToggleSwitch"
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/SmartParkingActions";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faTrash,
  faPlus,
  faEdit,
  faParking,
} from "../../assets/consts/faCharCodes";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import PropTypes from "prop-types";
import Loading from "../components/Loading";

import SmartParking, { ParkingArea } from "../viewModels/SmartParking";
import { ScenarioListItem } from "./ScenarioListScreen";
import InputBase from "../nativeBase-ui/InputBase";
import { HStack, VStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import InputSearch from "../components_v2/InputSearch";
import ModalBase from "../nativeBase-ui/ModalBase";
import { getDir } from "../util";
// import SearchableDropdown from "../components/SearchableDropDown";
// === Model SmartParking ===
var modelSmartParking = new SmartParking();
const modelParkingArea = new ParkingArea();

/**@augments{Component<props,state>} */
class SmartParkingFloor extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    smartParkingId: PropTypes.string,
    taplifeControllerId: PropTypes.string,
    onNameChange: PropTypes.func,
    onLevelChange: PropTypes.func,
    onDelete: PropTypes.func,
    onChangeController: PropTypes.func,
  };
  constructor(props) {
    super(props);
    let { id, name, parkingLots } = this.props;
    this.state = {
      id,
      name,
      storageServerId: null,
      parkingLots,

      showModalAddParkingLot: false,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  handleOnNameChange = (name) => {
    this.setState({ name }, () => {
      this.props.onNameChange && this.props.onNameChange(name);
    });
  };

  handleOnDelete = () => {
    this.setState({ id: "", name: "", storageServerId: "", parkingLots: [] });
    this.props.onDelete && this.props.onDelete(this.state.id);
  };
  handlerOnSelectController = (storageServerId) => {
    this.setState({ storageServerId }, () => {
      typeof this.props.onChangeController === "function" &&
        this.props.onChangeController(storageServerId);
    });
  };
  handlerAddParkingLots = (parkingLot) => {
    this.setState(
      {
        parkingLots: [...this.state.parkingLots, parkingLot],
        showModalAddParkingLot: false,
      },
      () => {
        typeof this.props.onAddParkingLot === "function" &&
          this.props.onAddParkingLot(parkingLot);
      }
    );
  };
  handlerUpdateParkingLot = (newParkingLot) => {
    var updateParkingLot = this.props.parkingLots.map(
      (item) => newParkingLot.find((o) => o.id === item.id) || item
    );
    this.setState(
      {
        parkingLots: updateParkingLot,
      },
      () => {
        typeof this.props.onAddParkingLot === "function" &&
          this.props.onUpdateParkingLot(this.state.parkingLots);
      }
    );
  };
  render() {
    return (
      <View
        style={{
          flexDirection: "row",
          marginVertical: 5,
          padding: 10,
          // paddingVertical: 10,
          alignItems: "center",
          borderRadius: 10,

          backgroundColor: Theme.COLORS.WHITE,
          shadowColor: Theme.COLORS.MUTED,
          marginBottom: 10,
          shadowOffset: {
            width: 0,
            height: 3,
          },
          shadowOpacity: 0.2,
          shadowRadius: 6.65,
          elevation: 4,
        }}
      >
        <View style={{ flex: 1 }}>
          <View
            style={{
              paddingTop: 2,
              paddingStart: 3,
              alignItems: "flex-end",
              padding: 0,
              marginTop: Platform.OS == "web" ? -5 : 0,
            }}
          >
            <TouchableHighlight
              underlayColor="transparent"
              style={{
                width: 35,
                height: 35,
                backgroundColor: Theme.COLORS.ERROR,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 5,
              }}
              onPress={this.handleOnDelete}
            >
              <FontAwesomeIcon icon={faTrash} color="#FFF" size={16} />
            </TouchableHighlight>
          </View>
          <View
            style={{
              flex: 1,
              flexDirection: "column",
            }}
          >
            <InputBase
              // containerStyle={{ backgroundColor: Theme.COLORS.LIGHT_MAIN }}
              placeholder={translate("smartParking.floorLabel")}
              label={translate("smartParking.floorLabel")}
              onChangeText={(txt) => this.handleOnNameChange(txt)}
              value={this.state.name}
              icon={faEdit}
            />
            {/* storage server */}
            <View style={{ marginTop: 10 }}>
              <Select
                label={translate("deviceGroup.controller")}
                value={
                  this.state.storageServerId ||
                  this.props.parkingFloors.taplifeControllerId
                    ? this.props.parkingFloors.taplifeControllerId
                    : null
                }
                data={this.props.dataControllerId}
                onChangeText={(controllerId) =>
                  this.handlerOnSelectController(controllerId)
                }
              />
            </View>
            <TouchableHighlight
              color="primary"
              onPress={() => this.setState({ showModalAddParkingLot: true })}
              style={[style.btn, { width: "100%", marginTop: 20 }]}
            >
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <FontAwesomeIcon icon={faPlus} size={16} color="#FFF" />
                <Text
                  style={{ color: Theme.COLORS.WHITE, marginHorizontal: 10 }}
                >
                  {translate("smartParking.addParkingLot")}
                </Text>
              </View>
            </TouchableHighlight>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 10,
              }}
            >
              <Text style={{ fontSize: 16, marginHorizontal: 5, width: "50%" }}>
                {translate("smartParking.numberOfParking")} :{" "}
                {this.state.parkingLots.length}
              </Text>
              <ArButton
                color="primary"
                onPress={() =>
                  this.props.navigation.navigate("ParkingLotsListScreen", {
                    parkingLots: this.state.parkingLots,
                    updateParkingLot: (parkingLots) => {
                      this.handlerUpdateParkingLot([parkingLots]);
                      // var _parkingLot = { ...this.state.parkingLots }
                      // for (let i in _parkingLot) {
                      //   if (_parkingLot[i].id === parkingLots.id) {
                      //     _parkingLot[i] = parkingLots
                      //   }
                      // }
                      // this.setState({ parkingLots: _parkingLot })
                      // console.log(_parkingLot)
                      // console.log(parkingLots)
                      // console.log(this.state.parkingLots)
                    },
                  })
                }
                style={{
                  flex: 1,
                  marginHorizontal: 0,
                  // marginLeft: 3,
                  padding: 10,
                  marginVertical: 15,
                }}
              >
                {translate("smartParking.parkingLotsList")}
              </ArButton>
            </View>
          </View>
        </View>
        {/* === modal add Parking Lot === */}
        {this.state.showModalAddParkingLot && (
          <ModalBase
            isOpen={this.state.showModalAddParkingLot}
            onClose={() => this.setState({ showModalAddParkingLot: false })}
          >
            <View
              style={{
                borderRadius: 5,
                height: "100%",
                padding: 10,
                width: "100%",
              }}
            >
              <SmartParkingLot
                smartPaking={this.props.smartPaking}
                closeModal={() =>
                  this.setState({ showModalAddParkingLot: false })
                }
                scenarios={this.props.scenarios}
                addParkingLot={(parkingLot) =>
                  this.handlerAddParkingLots(parkingLot)
                }
                updateParkingLot={(updateParkingLot) => {
                  this.handlerUpdateParkingLot(updateParkingLot);
                }}
              />
            </View>
          </ModalBase>
        )}
      </View>
    );
  }
}
export class SmartParkingLot extends Component {
  static propTypes = {
    id: PropTypes.string,
    parkingLotName: PropTypes.string,
    smartParkingId: PropTypes.string,
    parkingLotNumber: PropTypes.number,
    taplifeControllerId: PropTypes.string,
    onNameChange: PropTypes.func,
    onLevelChange: PropTypes.func,
    onChangeController: PropTypes.func,
    addParkingLot: PropTypes.func,
    inputSearch: PropTypes.string,
    smartParking: PropTypes.array,
  };
  constructor(props) {
    const tempId = (
      performance.now().toString(36) + Math.random().toString(36)
    ).replace(/\./g, "");
    super(props);
    this.state = {
      id: this.props.id || tempId,
      parkingLotName: this.props.parkingLotName || "",
      parkingLotNumber: this.props.parkingLotNumber || 1,
      parkingAreaId: this.props.parkingAreaId || "",
      status: this.props.status || "Available",
      scenarioId: this.props.scenarioId || null,
      scenarioUId: this.props.scenarioUId || null,
      isModalScenarioList: false,
      inputSearch: "",
      selectScenarioName: null,
    };
  }
  addParkingLotHandler = (dataParkingLot) => {
    typeof this.props.addParkingLot === "function" &&
      this.props.addParkingLot(dataParkingLot);
  };
  updateParkingLotHandler = (dataParkingLot) => {
    typeof this.props.updateParkingLot === "function" &&
      this.props.updateParkingLot(dataParkingLot);
  };
  componentDidMount() {
    const { scenarioId, scenarioUId } = this.props;
    const tempId = (
      performance.now().toString(36) + Math.random().toString(36)
    ).replace(/\./g, "");

    const selectScenarioNameById = this.props.scenarios.scenarios.find(
      (item) => {
        return item.id == scenarioId || (item.uId && item.uId == scenarioUId);
      }
    )?.name;
    this.setState({
      selectScenarioName: selectScenarioNameById || null,
    });
  }
  render() {
    // === Filter Scenarios ===
    const { inputSearch } = this.state;
    const filteredSenarios = this.props.scenarios?.scenarios.filter((item) => {
      return item.name.toLowerCase().indexOf(inputSearch.toLowerCase()) !== -1;
    });

    const dataParkingStatus = [
      {
        label: translate("smartParking.parkingStatusList.Available"),
        value: "Available",
      },
      {
        label: translate("smartParking.parkingStatusList.Occupying"),
        value: "Occupying",
      },
      {
        label: translate("smartParking.parkingStatusList.Occupied"),
        value: "Occupied",
      },
      {
        label: translate("smartParking.parkingStatusList.OutOfService"),
        value: "OutOfService",
      },
      {
        label: translate("smartParking.parkingStatusList.Reserved"),
        value: "Reserved",
      },
    ];
    return (
      <View
        style={{
          // flexDirection: "row",
          // marginVertical: 15,
          padding: 5,
          paddingVertical: 10,
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 5,
          // flex: 1,
          direction: getDir(),
          width: "100%",
          // height: "95%",
          // backgroundColor: ArTheme.COLORS.LIGHT_MAIN,
        }}
      >
        <ScrollView style={{ flex: 1, width: "100%" }}>
          <View
            style={{
              // flex: 1,
              flexDirection: "column",
              width: "100%",
            }}
          >
            {/* === parking Lot Name == */}
            <InputBase
              // containerStyle={{ backgroundColor: Theme.COLORS.LIGHT_MAIN }}
              placeholder={translate("smartParking.parkingName")}
              label={translate("smartParking.parkingName")}
              onChangeText={(txt) => this.setState({ parkingLotName: txt })}
              value={this.state.parkingLotName}
              icon={faParking}
            />
            {/* === Parking Lot Number === */}
            <InputBase
              containerStyle={{
                marginVertical: 10,
                // backgroundColor: Theme.COLORS.LIGHT_MAIN,
              }}
              keyboardType="phone-pad"
              placeholder={translate("smartParking.parkingNumber")}
              label={translate("smartParking.parkingNumber")}
              onChangeText={(num) => this.setState({ parkingLotNumber: num })}
              value={this.state.parkingLotNumber}
              icon={faParking}
            />
            {/* === status Parking Lot === */}
            <Select
              label={translate("smartParking.parkingStatus")}
              value={this.state.status}
              data={dataParkingStatus.map((item) => {
                return {
                  value: item.value || "",
                  label: item.label,
                };
              })}
              onChangeText={(parkingStaus) =>
                this.setState({ status: parkingStaus })
              }
            />
            {/* === === Select Scenario === */}
            <View
              style={{
                marginVertical: 10,
                width: "100%",
                // flexDirection: "row",
                // alignItems: "center",
                // justifyContent: "space-between",
              }}
            >
              <Text style={{ marginVertical: 5 }}>
                {translate("smartParking.selectingScenarioWhenUserEnters")}:{" "}
              </Text>
              <HStack justifyContent="space-between" alignItems="center">
                {this.state.selectScenarioName ? (
                  <Text> {this.state.selectScenarioName}</Text>
                ) : (
                  <Text>{translate("app.default")}</Text>
                )}
                <ArButton
                  color="primary"
                  onPress={() => {
                    this.setState({ isModalScenarioList: true });
                  }}
                  style={{
                    width: "50%",
                    // height: 40,
                  }}
                >
                  {translate("area.definedScenarios")}
                </ArButton>
              </HStack>
            </View>

            {/* === modal Screnaios list === */}
            {this.state.isModalScenarioList && (
              <ModalBase
                isOpen={this.state.isModalScenarioList}
                onClose={() => this.setState({ isModalScenarioList: false })}
              >
                <View
                  style={{
                    borderRadius: 5,
                    height: "100%",
                    direction: getDir(),
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: 45,
                      marginHorizontal: 15,
                      marginVertical: 15,
                      marginBottom: 15,
                    }}
                  >
                    <InputSearch
                      searchContainer={{
                        flex: 2,
                      }}
                      containerStyle={{
                        width: "100%",
                        // backgroundColor: Theme.COLORS.LIGHT_MAIN,
                      }}
                      placeholder={translate("app.search")}
                      onChangeText={(txt) =>
                        this.setState({ inputSearch: txt })
                      }
                      value={this.state.inputSearch}
                    />
                    {/* === Random Select === */}
                    <TouchableHighlight
                      onPress={() => {
                        this.setState({
                          selectScenarioName: translate("app.default"),
                          scenarioId: null,
                          scenarioUId: null,
                          isModalScenarioList: false,
                        });
                      }}
                      underlayColor={Theme.COLORS.LIGHT_MAIN}
                      style={{
                        flex: 1,
                        padding: 10,
                        height: 45,
                        minWidth: 100,
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: Theme.COLORS.BACKGROUND,
                        borderRadius: 5,
                        marginHorizontal: 5,

                        shadowColor: Theme.COLORS.BACKGROUND,
                        shadowOffset: {
                          width: 0,
                          height: 3,
                        },
                        shadowOpacity: 0.3,
                        shadowRadius: 5.5,
                        elevation: 9,
                      }}
                    >
                      <Text style={{ color: Theme.COLORS.BLACK }}>
                        {translate("app.default")}
                      </Text>
                    </TouchableHighlight>
                  </View>
                  {/* === Scenario list === */}
                  <ScrollView
                    style={{
                      flex: 1,
                      borderRadius: 15,
                      padding: 15,
                      backgroundColor: Theme.COLORS.LIGHT_MAIN,
                    }}
                  >
                    {this.props.scenarios.scenarios ? (
                      filteredSenarios.map((item) => {
                        return (
                          <ScenarioListItem
                            key={item.id}
                            scenario={item}
                            onPress={() => {
                              this.setState({
                                selectScenarioName: item.name,
                                scenarioId: item.id || null,
                                scenarioUId: item.uId || null,
                                isModalScenarioList: false,
                              });
                            }}
                          />
                        );
                      })
                    ) : (
                      <Text style={{ textAlign: "center" }}>
                        {translate("app.emptyList")}
                      </Text>
                    )}
                  </ScrollView>
                </View>
              </ModalBase>
            )}
          </View>
          <HStack space={2} style={{ width: "100%" }}>
            <ArButton
              color="primary"
              onPress={() => {
                const parkingLot = {
                  id: this.state.id,
                  name: this.state.parkingLotName,
                  parkingNumber: Number(this.state.parkingLotNumber),
                  parkingAreaId: this.state.parkingAreaId,
                  status: this.state.status,
                  scenarioId: this.state.scenarioId,
                  scenarioUId: this.state.scenarioUId,
                };
                this.props.id !== this.tempId
                  ? this.updateParkingLotHandler(parkingLot)
                  : this.addParkingLotHandler(parkingLot);
              }}
              style={{
                flex: 1,
                // width: "100%",
                // height: 40,
                marginBottom: 0,
              }}
            >
              {this.props.editMode
                ? translate("app.applyChanges")
                : translate("smartParking.addParkingLot")}
            </ArButton>
            {!this.props.editMode && (
              <ArButton
                variant="outline"
                color="muted"
                onPress={() => {
                  this.props.closeModal();
                }}
                style={{
                  flex: 1,
                  marginBottom: 0,
                }}
              >
                {translate("api.cancel")}
              </ArButton>
            )}
          </HStack>
        </ScrollView>
      </View>
    );
  }
}
class SmartParkingFormScreen extends Component {
  constructor(props) {
    super(props);
    let id = undefined;
    if (this.props.navigation.state.params) {
      id = this.props.navigation.state.params.smartParkingId;
      // let areaId = undefined;
      // areaId = this.props.navigation.state.params.areaId;
    }
    this.state = {
      id: id || "",
      accessToken: "",
      isLoading: true,
      parkingId: "",
      areaName: "",
      parkingFloors: [modelParkingArea],
      miss_areaName: false,
      showOnHomeScreen: false,
      buildingId: "",
      parkingLotName: "",
    };
  }

  componentDidMount() {
    // TODO === change to area Type ===
    if (this.props.navigation.state.params) {
      let { id, smartParkingId } = this.props.navigation.state.params;
      // if (id) {
      //   for (var i in this.props.AreaReducer.parkings) {
      //     var device = this.props.AreaReducer.parkings[i];
      //     if (device.id == smartParkingId) {
      //       this.setState({
      //         isLoading: false,
      //         parkingId: device.id,
      //         areaName: device.name,
      //         parkingFloors:device.parkingAreas
      //         // showOnHomeScreen: device.showOnHomeScreen || false,
      //       });
      //     }
      //   }
      // } else
      if (smartParkingId) {
        for (var i in this.props.AreaReducer.parkings) {
          var device = this.props.AreaReducer.parkings[i];
          if (device.id == smartParkingId) {
            this.setState({
              isLoading: false,
              id: device.id,
              areaName: device.name,
              parkingFloors: device.parkingAreas,
            });
          }
        }
      } else {
        //new elevator
        this.setState({
          isLoading: false,
        });
      }
    } else {
      this.setState({ isLoading: false });
    }
    this.getAccessTokenAsync();
  }
  getAccessTokenAsync = async () => {
    if (!this.state.accessToken) {
      try {
        var { accessToken } = this.props.appReducer?.currentServer;
        this.setState({ accessToken });
      } catch (err) {
        console.log(err);
      }
    }
  };

  addFloor() {
    let { parkingFloors } = this.state;
    var modelParkingArea = new ParkingArea();
    if (parkingFloors.length > 0) {
      var prevFloor = parkingFloors.slice(-1)[0];
      if (Number(prevFloor.name)) {
        modelParkingArea.name = (Number(prevFloor.name) + 1).toString();
      }
    }
    parkingFloors.push(modelParkingArea);

    this.setState({ parkingFloors });
  }

  goBack = () => {
    this.props.navigation.goBack();
    // callback
    // this.props.navigation.state.params.onGoBack &&
    //   this.props.navigation.state.params.onGoBack(DeviceTypes.ELEVATOR);
  };
  save = () => {
    let { id, areaName, parkingFloors, showOnHomeScreen } = this.state;
    modelSmartParking = {
      id,
      name: areaName,
      buildingId: this.props.appReducer.currentBuilding.buildingId,
      parkingAreas: parkingFloors,
      // showOnHomeScreen,
    };
    // console.log('modelSmartParking', modelSmartParking)
    let errors = [];
    if (!modelSmartParking.name) {
      errors.push(
        `${translate("smartParking.parkingName")} ${translate(
          "app.isRequired"
        )}`
      );
    }
    if (errors.length > 0) {
      alert(errors.join("\r\n"));
      return;
    }
    if (!modelSmartParking.id == "") {
      this.props.update(modelSmartParking, this.state.accessToken);
    } else {
      this.props.add(modelSmartParking, this.state.accessToken);
    }

    this.goBack();
  };
  render() {
    // let { smartParkingId } = this.props.navigation.state?.params;
    const screenTitle = this.state.id
      ? this.state.areaName || translate("app.noName")
      : translate("smartParking.createNewParking");
    if (this.state.isLoading) {
      return <Loading />;
    }
    return (
      <KeyboardAvoidingView
        // behavior="padding"
        style={{ flex: 1 }}
        // enabled={true}
        // keyboardVerticalOffset={80}
      >
        <ScrollView style={style.containerScroll}>
          <Text style={style.screenTitle}>{screenTitle}</Text>
          {/* smartParking name */}
          <InputBase
            isInValid={this.state.miss_areaName}
            label={translate("smartParking.parkingName")}
            onChangeText={(txt) =>
              this.setState({
                areaName: txt,
                miss_parkingName: txt.length == 0,
              })
            }
            value={this.state.areaName}
            icon={faParking}
          />
          {/* showOnHomeScreen */}
          {/* {this.state.showOnHomeScreen != undefined && (
            <View style={{ flexDirection: "row", marginTop: 15 }}>
              <Switch
                isOn={this.state.showOnHomeScreen}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  this.setState({ showOnHomeScreen: v });
                }}
                animationSpeed={0}
              />
              <Text style={{ marginHorizontal: 5 }}>
                {translate("device.showOnHomeScreen")}
              </Text>
            </View>
          )} */}
          {/* start of add and delete floors*/}
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              style={{
                height: 30,
                textAlignVertical: "center",
                padding: 12,
                marginBottom: 10,
              }}
            >
              {translate("smartParking.floors")}
            </Text>
          </View>
          {this.state.parkingFloors.map((chn, idx) => {
            return (
              <SmartParkingFloor
                smartPaking={this.props.AreaReducer.parkings}
                navigation={this.props.navigation}
                scenarios={this.props.scenarios}
                key={idx}
                name={chn.name}
                parkingFloors={chn}
                parkingLots={chn.parkingLots}
                taplifeControllerId={chn.taplifeControllerId}
                dataControllerId={this.props.reducer.list
                  .filter((d) => d.deviceType == DeviceTypes.TAPLIFE_CONTROLLER)
                  .map((d) => {
                    return {
                      value: d.taplifeControllerId || "",
                      label: d.deviceName,
                    };
                  })}
                onChangeController={(controllerId) => {
                  let _parkingFloors = [...this.state.parkingFloors];
                  _parkingFloors[idx].taplifeControllerId = controllerId;
                  this.setState({ parkingFloors: _parkingFloors });
                }}
                onNameChange={(name) => {
                  let _parkingFloors = [...this.state.parkingFloors];
                  _parkingFloors[idx].name = name;
                  this.setState({ parkingFloors: _parkingFloors });
                }}
                onDelete={() => {
                  let _parkingFloors = [...this.state.parkingFloors];
                  _parkingFloors.splice(idx, 1);
                  if (_parkingFloors.length == 0) {
                    _parkingFloors = [];
                  }
                  this.setState({ parkingFloors: _parkingFloors });
                }}
                onAddParkingLot={(parkingLot) => {
                  let _parkingFloors = [...this.state.parkingFloors];
                  _parkingFloors[idx].parkingLots = [
                    ..._parkingFloors[idx].parkingLots,
                    parkingLot,
                  ];
                  this.setState({ parkingFloors: _parkingFloors });
                }}
                onUpdateParkingLot={(parkingLot) => {
                  let _parkingFloors = [...this.state.parkingFloors];
                  _parkingFloors[idx].parkingLots = parkingLot;
                  this.setState({ parkingFloors: _parkingFloors });
                }}
              />
            );
          })}
          <TouchableHighlight
            underlayColor="transparent"
            style={{
              width: 100,
              height: 35,
              backgroundColor: Theme.COLORS.SUCCESS,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 5,
              marginEnd: 5,
              marginStart: 10,
              marginTop: 15,
            }}
            onPress={() => {
              this.addFloor();
            }}
          >
            <FontAwesomeIcon icon={faPlus} color="#FFF" />
          </TouchableHighlight>
          {/* <ArButton
            color="success"
            style={{
              width: 100,
              height: 30,
              alignSelf: "flex-start",
            }}
          >
            <View
              style={{
                flexDirection: "row-reverse",
              }}
            ></View>
          </ArButton> */}

          {/* end of add and delete floors*/}
          {/*/start of goBack and save button */}
          <HStack
            space={2}
            style={{
              marginTop: 10,
            }}
          >
            <ArButton
              color="muted"
              onPress={() => this.goBack()}
              style={{ flex: 1 }}
            >
              {translate("app.goBack")}
            </ArButton>
            <ArButton
              color="primary"
              onPress={() => this.save()}
              style={{ flex: 1 }}
            >
              {translate("app.save")}
            </ArButton>
          </HStack>
          {/*/end of goBack and save button */}
        </ScrollView>
      </KeyboardAvoidingView>
    );
  }
}

const btnStyle = {
  flex: 1,
  margin: 3,
  padding: 3,
  borderRadius: 3,
  height: 45,
  alignItems: "center",
  justifyContent: "center",
};

const style = StyleSheet.create({
  containerScroll: {
    marginVertical: 5,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  container: {
    backgroundColor: Theme.COLORS.LIGHT_MAIN,
    borderRadius: 10,
    marginBottom: 12,
    padding: 15,
    paddingHorizontal: 12,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  selectContainer: {
    width: "100%",
    // flexDirection: "row",
    alignItems: "center",
    // justifyContent: "space-between",
    minHeight: 85,
  },
  btn: {
    // flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 18,
    // width: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Theme.COLORS.PRIMARY,
    borderRadius: 5,
    minWidth: 130,

    shadowColor: Theme.COLORS.PRIMARY,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
    AreaReducer: state.AreaReducer,
    scenarios: state.ScenarioReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (model, accessToken) => {
      dispatch(Actions.Add(model, accessToken));
    },
    update: (model, accessToken) => {
      dispatch(Actions.Update(model, accessToken));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmartParkingFormScreen);
